<div class="row">
  <h2 class="offset-md-1 col-md-10">Confirmation Orphans Report</h2>
</div>
<div class="row">
  <div class="col-12">
    <form keepingCurrentReportForm #form
          [showDateRange]="true"
          [showAgencies]="true" novalidate>
      <button type="submit" class="btn btn-primary" (click)="submitReport()">Submit</button>
      <a class="btn btn-primary" [href]="form.downloadConfirmationOrphansReport()">Export to Excel</a>
    </form>
    <reportTable [rows]="rows | async" [headers]="tableHeaders"></reportTable>
  </div>
</div>
